import { render, staticRenderFns } from "./ComponentSettings.vue?vue&type=template&id=94dacc02&scoped=true"
import script from "./ComponentSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentSettings.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ComponentSettings.vue?vue&type=style&index=0&id=94dacc02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dacc02",
  null
  
)

export default component.exports